import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CheckboxRadioItem } from '@work4all/components/lib/input/checkbox-radio-item';

import { useTenant } from '@work4all/data/lib/hooks/routing/TenantProvider';

import { useUserMailboxExchangeSynchronizationOptions } from '../exchange-synchronization/hooks/use-user-mailbox-exchange-synchronization-options';

export const DataProtection = () => {
  const { t } = useTranslation();
  const tenantId = useTenant();
  const { privacyHideBirthday, allowToUseOwnPrivateData } =
    useUserMailboxExchangeSynchronizationOptions({
      tenantId: tenantId.activeTenant,
    });

  return (
    <Stack p="2rem">
      <CheckboxRadioItem
        control="checkbox"
        label={t(
          'EXCHANGE_SYNCHRONIZATION.PERMISSIONS.ALLOW_TO_USE_OWN_PRIVATE_DATA'
        )}
        checked={allowToUseOwnPrivateData.value}
        onChange={() => {
          allowToUseOwnPrivateData.set(!allowToUseOwnPrivateData.value);
        }}
      />
      <CheckboxRadioItem
        control="checkbox"
        label={t(
          'EXCHANGE_SYNCHRONIZATION.PERMISSIONS.ALLOW_TO_USE_OWN_BIRTHDAY'
        )}
        checked={!privacyHideBirthday.value}
        onChange={() => {
          privacyHideBirthday.set(!privacyHideBirthday.value);
        }}
      />
    </Stack>
  );
};
